import { CommandCode } from "../../utils/network/generated/protoTypes";
import { networkNoticeCoopMemberInfoHandler } from "./handlers/networkNoticeCoopMemberInfoHandler";
import { networkNoticeGrantCoopRewardHandler } from "./handlers/networkNoticeGrantCoopRewardHandler";
import { networkNoticeGrantRewardHandler } from "./handlers/networkNoticeGrantRewardHandler";
import { networkNoticeKickedCoopMemberInfoHandler } from "./handlers/networkNoticeKickedCoopMemberInfoHandler";
import { networkNoticePendingInventoryInfoHandler } from "./handlers/networkNoticePendingInventoryInfoHandler";
import { networkNoticePurchasePointsUpdateHandler } from "./handlers/networkNoticePurchasePointsUpdateHandler";
import { networkNoticeQuestUpdateHandler } from "./handlers/networkNoticeQuestUpdateHandler";
import { networkNoticeSubscriptionUpdateHandler } from "./handlers/networkNoticeSubscriptionUpdateHandler";
import { networkNoticeUpdateCollectLeagueEventHandler } from "./handlers/networkNoticeUpdateCollectLeagueEventHandler";
export var networkNoticeHandlerMap = new Map()
    .set(CommandCode.QuestUpdate, networkNoticeQuestUpdateHandler)
    .set(CommandCode.GrantReward, networkNoticeGrantRewardHandler)
    .set(CommandCode.GrantCoopReward, networkNoticeGrantCoopRewardHandler)
    .set(CommandCode.PendingInventoryInfo, networkNoticePendingInventoryInfoHandler)
    .set(CommandCode.UpdatePurchasePointEvent, networkNoticePurchasePointsUpdateHandler)
    .set(CommandCode.SubscriptionChangeInfo, networkNoticeSubscriptionUpdateHandler)
    .set(CommandCode.CoopMemberInfo, networkNoticeCoopMemberInfoHandler)
    .set(CommandCode.UpdateCollectLeagueEvent, networkNoticeUpdateCollectLeagueEventHandler)
    .set(CommandCode.KickedCoopMemberInfo, networkNoticeKickedCoopMemberInfoHandler);



//////////////////
// WEBPACK FOOTER
// ./src/features/network/networkNoticeHandlerMap.ts
// module id = 2008
// module chunks = 3